import { Children } from 'react'
import PropTypes from 'prop-types'
import pick from 'lodash/pick'
import map from 'lodash/map'
import compact from 'lodash/compact'
import {
  setDisplayName,
  compose,
  mapProps,
  withContext,
  withProps,
  withState,
} from 'recompose'

const propTypes = {
  initialStep: PropTypes.string,
}

export const CONTEXT = {
  currentStep: PropTypes.string,
  restart: PropTypes.func,
  goBack: PropTypes.func,
  goForward: PropTypes.func,
  goTo: PropTypes.func,
}

export const CONTEXT_KEYS = Object.keys(CONTEXT)

const getSteps = children => {
  const childrenArray = Children.toArray(children)
  const mappedChildrenArray = map(childrenArray, 'props.step')
  const compactedChildrenArray = compact(mappedChildrenArray)
  return compactedChildrenArray
}

const WizardProvider = compose(
  setDisplayName('Wizard'),
  withProps(({ initialStep, children }) => {
    const steps = getSteps(children)
    return {
      initialStep: steps.includes(initialStep) ? initialStep : steps[0],
      steps,
    }
  }),
  withState('currentStep', 'setStep', ({ initialStep }) => initialStep),
  withProps(
    ({
      onStepChange = () => {},
      currentStep,
      setStep,
      steps,
      initialStep,
    }) => ({
      restart: () => setStep(initialStep, onStepChange(initialStep)),
      goBack: () => {
        const current = steps.indexOf(currentStep)
        const newStep = steps[Math.max(0, current - 1)]
        setStep(newStep, onStepChange(newStep))
      },
      goForward: () => {
        const current = steps.indexOf(currentStep)
        const maxStep = steps.length - 1
        const newStep = steps[Math.min(maxStep, current + 1)]
        setStep(newStep, onStepChange(newStep))
      },
      goTo: stepName => {
        if (steps.includes(stepName)) {
          setStep(stepName, onStepChange(stepName))
        }
      },
    })
  ),
  withContext(CONTEXT, props => pick(props, CONTEXT_KEYS)),
  mapProps(({ children }) => ({ children }))
)

WizardProvider.propTypes = propTypes

export default WizardProvider
